import { InboundReferenceCollection, ProductInboundTransactionDoc } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';
import { WHERE } from 'src/utils/firebase/firebase-manager';
import { getCollectionCount, observeProductInboundTransaction } from 'src/utils/firebase/firebase-short-cut';

const MAX_TRANSACTIONS = 5000; // 최대 허용 트랜잭션 수

const tabToWheres: Record<string, WHERE[]> = {
  all: [],
  supplier: [['referenceCollection', '==', InboundReferenceCollection.PRODUCT_SUPPLIER]],
  issue: [['referenceCollection', '==', InboundReferenceCollection.INVENTORY_ISSUE]],
  store: [['referenceCollection', '==', InboundReferenceCollection.STORE_ISSUE]],
};

const useInboundTransactions = (tab: string, startValue: string, endValue: string) => {
  const [loading, setLoading] = useState(false);
  const [inboundTransactions, setInboundTransactions] = useState<ProductInboundTransactionDoc[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const checkCount = async () => {
      try {
        const countSnapshot = await getCollectionCount('productInboundTransaction', tabToWheres[tab], {
          sortKey: 'requestDate',
          orderBy: 'desc',
          startValue,
          endValue,
        });

        const count = countSnapshot.data().count;
        if (count > MAX_TRANSACTIONS) {
          setError(
            `데이터가 너무 많습니다 (${count}건 / 최대 ${MAX_TRANSACTIONS}건). 날짜 범위를 좁혀서 다시 시도해주세요.`
          );
          setLoading(false);
          return false;
        }
        return true;
      } catch (err) {
        setError('데이터 수를 확인하는 중 오류가 발생했습니다.');
        setLoading(false);
        return false;
      }
    };

    const initializeSubscription = async () => {
      const isValidCount = await checkCount();
      if (!isValidCount) return;

      const inboundTransaction$ = observeProductInboundTransaction(tabToWheres[tab], {
        sortKey: 'requestDate',
        orderBy: 'desc',
        startValue,
        endValue,
      });

      const subscription = inboundTransaction$.subscribe((inboundTransactions) => {
        setInboundTransactions(
          inboundTransactions
            .sort((a, b) => b._timeCreate.toDate().getTime() - a._timeCreate.toDate().getTime())
            .sort((a, b) => b.requestDate.localeCompare(a.requestDate))
        );
        setLoading(false);
      });

      return subscription;
    };

    let subscription: any;
    initializeSubscription().then((sub) => {
      subscription = sub;
    });

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, [startValue, endValue, tab]);

  return { inboundTransactions, loading, error };
};

export default useInboundTransactions;
